import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Button,
  Skeleton,
  Table,
  Result,
  Checkbox,
  ConfigProvider,
} from "antd";

import {
  formatDateTime,
  generatedISOFormatDateString,
  getLastDayTimeRangeIST,
  getLastDayTimeRangeUTC,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useSelector } from "react-redux";
import TableComponent from "../../../../../Elements/Grid/TableComponent";
import TableComponentReport from "../../../../../Elements/Grid/TableComponentReport";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { FilterOutlined } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";
import SteamTreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";


// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 
const ConsumptionReportElectrical = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1);
  const [converterId, setConverterId] = useState(1);
  const [report, setReport] = useState([]);
    const [selectedMeterIds, setSelectedMeterIds] = useState(["1","2","3","4","9","10","11","12"]);
     const [selectedValues, setSelectedValues] = useState(["KWHTOTAL"]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartConverterInput, setChartConverterInput] = useState();
  const [chartGroupInput, setChartGroupInput] = useState();
  const [submit, setSubmit] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [converterGroupId, setConverterGroupId] = useState("1");
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [paraError, setParaError] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
    const [meterError, setMeterError] = useState();

  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =
    useState([]);

       const[getElectricGroupMeterList,setGetElectricGroupMeterList]=useState([])
   const[nsGetElectricConverterMeterList,setNsGetElectricConverterMeterList]=useState([])
  const [consumptionData, setConsumptionData] = useState([]);
  const [loadings, setLoadings] = useState(true);

  const [checkedValue, setCheckedValue] = useState(null);
  const [isLast24Hours, setIsLast24Hours] = useState(false);
  const [time, setTime] = useState(false);
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);
  const [datesError, setDatesError] = useState(null);
  const [excelToDate, setExcelToDate] = useState(null);
  const [excelFromDate, setExcelFromDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
    const [parameter, setParameter] = useState([]);
  const [value, setValue] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")]);
    const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [fromDateString, setFromDateString] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateObj, setToDateObj] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateString, setToDateString] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
    const [excelImage, setExcelImage] = useState(null);
   const loggedIn = useSelector((state) => state.user);
  // console.log(loggedIn)
  useEffect(()=>{

    setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
  },[loggedIn])

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res);
      }
    });
 
  }, []);
  useEffect(() => {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_HISTORICAL_PARAMETERS_LIST}`,
      }).then((res) => {
        console.log(res);
        if (res && res.length > 0) {
          setParameter(res);
        }
      });
 
  }, []);
  



  useEffect(()=>{
    if(sectionId==1){
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowConverterResData(res);
        }
      });

    }
    if(sectionId==2){
      
        makeRequest({
          type: APIConstants.POST,
          url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
        }).then((res) => {
          // //console.log(res);
          if (res && res.length > 0) {
            setflowGroupDetailsResData(res);
          }
        });

    }

  },[sectionId])


 useEffect(() => {
  console.log()
    if (converterGroupId && sectionId==1) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_METERS_LIST}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setNsGetElectricConverterMeterList(res);
        }
      });
    }

    if (converterGroupId&& sectionId==2) {
      makeRequest({
        type: APIConstants.POST,
       url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setGetElectricGroupMeterList(res);
        }
      });
    }

  }, [converterGroupId]);




  useEffect(() => {
    if (converterGroupId && sectionId==1) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setnsGetFlowConverterResData(res);
        }
      });
    }

    if (converterGroupId&& sectionId==2) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowSteamGroupMeterResData(res);
        }
      });
    }

  }, [converterGroupId]);

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];

  const fetchData = (data) => {
    //console.log(data);
        if(data&&data.sectionId&&data.ConverterID&&data.FromDate&&data.ToDate&&data.meterIds){
          setLoadings(true);

          // setExcelFromDate(data.FromDate);
          // setExcelToDate(data.ToDate);
          // //console.log(data);
          makeRequest({
            type: APIConstants.GET,
            url: `${APIConstants.ELECTRICAL_CONSUMPTION_REPORT}?SectionID=${data.sectionId}&ConverterorGroupID=${data.ConverterID} &MeterIds=${data.meterIds}&Parameters=${data.parameters}&FromDate=${data.FromDate}&ToDate=${data.ToDate}`,
          }).then((res) => {
            // //console.log(res);
            setLoadings(false);
            if (res && res.length > 0) {
              setConsumptionData(res);
            }
          });
      
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);

  let formattedFromDate;
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleChangeSection = (changedValues) => {
    // console.log(changedValues,'changed values')
    setSectionId(changedValues);
    setConverterId()
    setSelectedMeterIds([]);
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
   
       setConverterId(changedValues);
       setConverterGroupId(changedValues);

    if (changedValues) {
      setConverterError("");
      setSelectedMeterIds([])
    }
  };

    const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };
     const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);

    localStorage.setItem('selectedMeterIds', JSON.stringify(selectedValues));
    if (selectedValues) {
      setMeterError("");
    }
  };
  const onChangeFromDate = (dateString) => {
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const setChartInputConverterData = () => {
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);
 setExcelFromDate(formatDateTime(formattedFromDate))
    setExcelToDate(formatDateTime(formattedToDate))
    const ids = selectedMeterIds?.map((id) => id).join(",");

    const range = getLastDayTimeRangeIST();
    // //console.log("From:", range.from);
    // //console.log("To:", range.to);
    console.log(selectedValues)
    // console.log(selectedValues.join(','))
   const inputData1 = {
      sectionId: Number(sectionId) || 0,
      ConverterID: Number(converterId) || 0,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
      meterIds:selectedMeterIds||[],
      parameters:selectedValues,
    };
    const inputData2 = {
      sectionId: Number(sectionId) || 0,
      ConverterID: Number(converterId) || 0,
      FromDate: range.from || "2023-09-21 07:15:00.000",
      ToDate: range.to || "2023-09-25 07:15:00.000",
      
    };
    // const queryString = inputData;
    // //console.log(inputData2);
    // //console.log(inputData1);
    // setChartConverterInput(queryString);
    //console.log(isLast24Hours);
    if (isLast24Hours) {
    //   fetchData(inputData2);
    // } else {
    }
    console.log(inputData1)
    fetchData(inputData1);
  };

  useEffect(() => {
    setChartInputConverterData()
  }, []);
  useEffect(() => {
    setChartSkip(false);
    // if (sectionId == 1) {
    // setChartInputConverterData();
    // }

    // if (sectionId == 2) {
    //   setChartInputGroupData();
    // }
  }, [submit]);

  const validateInput = (value, label) => {
    const error = !value ? `Please select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterId, "Converter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(fromDateString, "From Date");
      const meterError = validateInput(selectedMeterIds.length, "Meter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
          setMeterError(meterError);


    if (!sectionError && !converterError&&!fromDateError&&!toDateError&&!datesError&&!meterError) {
      onClose();
      // setSubmit(!submit);
      // if (sectionId === 1) {
      // setChartConverterInput();
      setChartInputConverterData();
      // fetchData()
      setSubmit(!submit); // This might be causing continuous re-renders
      // } else if (sectionId === 2) {
      //   // setChartGroupInput();
      //   setChartInputGroupData()
      //   // fetchData()
      //   setSubmit(!submit); // This might be causing continuous re-renders
      // }
    }
  };
  let columns = [
    {
      title: "Meter ID",
      dataIndex: "meterid",
      fixed: "left",
      minWidth: "300px",
    },
    {
      title: "Site Name",
      dataIndex: "sitename",
      fixed: "left",
      minWidth: "300px",
    },
    {
      title: "Meter Name",
      dataIndex: "metername",
      fixed: "left",
      minWidth: "300px",
    },
    {
      title: "Opening ",
      dataIndex: "opening",
      fixed: "left",
      width: "200px",
    },
    {
      title: "Closing ",
      dataIndex: "closing",
      fixed: "left",
      width: "200px",
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      fixed: "left",
      width: "200px",
    },
  ];

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color);
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--date-ok-btn",
      color.themeConfig.colorPrimary
    );
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);

  // //console.log(consumptionData);

  const handleTimeRangeChange = () => {
    const now = dayjs();
    const fromTime = now.subtract(24, "hour");
    const fromTimeString = fromTime.format("YYYY-MM-DD HH:mm:ss");
    const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
    setFromDateObj(null);
    setToDateObj(null);
    //console.log("first");
    const range = getLastDayTimeRangeUTC();
    //console.log("From:", range.from);
    //console.log("To:", range.to);
    setFromDateString(range.from);
    setToDateString(range.to);
    setFrom(range.from);
    setTo(range.to);
    // setFromDateString(fromTimeString);
    // setToDateString(toTimeString);
    // setFrom(fromTimeString);
    // setTo(toTimeString);
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setIsLast24Hours(checked);
    setTime(!checked);

    if (checked) {
      handleTimeRangeChange();
    } else {
      setFromDateString(null);
      setToDateString(null);
      setFromDateObj(null);
      setToDateObj(null);
    }
  };

  // const exportToExcel = (data, fromDate, toDate) => {
  //   //console.log(data);

  //   // Prepare rows for the Excel sheet
  //   const rows = [];

  //   // Add a header row for the table
  //   const headers = [
  //     "Site Name",
  //     "Meter Name",
  //     "Meter ID",
  //     "Opening KWh Total",
  //     "Closing KWh Total",
  //     "Consumption",
  //   ];

  //   // Add "From Date" and "To Date" to the first row
  //   rows.push([
  //     `From: ${fromDate.replace("T", " ").replace(".000Z", " ") || "N/A"}`,
  //     `To: ${toDate.replace("T", " ").replace(".000Z", " ") || "N/A"}`,
  //     "",
  //     "",
  //     "",
  //     "",
  //   ]);

  //   // Add the headers row
  //   rows.push(headers);

  //   // Add data rows
  //   let totalConsumption = 0;
  //   data.forEach((item) => {
  //     const consumption = item.consumption || 0;
  //     totalConsumption += consumption;

  //     rows.push([
  //       item.sitename || "",
  //       item.metername || "",
  //       item.meterid || "",
  //       item.openingKwhTotal || 0,
  //       item.closingKwhTotal || 0,
  //       consumption,
  //     ]);
  //   });

  //   // Add a row for Total Consumption
  //   rows.push(["", "", "", "", "Total Consumption:", totalConsumption]);

  //   //console.log("Excel rows:", rows);

  //   // Create the Excel workbook and worksheet
  //   const workbook = XLSX.utils.book_new();
  //   const worksheet = XLSX.utils.aoa_to_sheet(rows);
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "SiteReport");

  //   // Generate the filename with a timestamp
  //   const now = new Date();
  //   const timestamp = now
  //     .toLocaleString("en-US", {
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //       hour: "2-digit",
  //       minute: "2-digit",
  //       second: "2-digit",
  //       hour12: false,
  //     })
  //     .replace(/[/,: ]/g, "-");

  //   const filename = `Consumption_Report_${timestamp}.xlsx`;
  //   //console.log("Generated Filename:", filename);

  //   // Write the file to the user's system
  //   XLSX.writeFile(workbook, filename);
  // };

  // //console.log(consumptionData);

  const getImageBufferFromUrl = async (url) => {
    const response = await fetch(url);
    return await response.arrayBuffer();
  };

  // asdas

const exportToExcel = async (data, fromDate, toDate) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("SiteReport");

  worksheet.mergeCells("A1:B2");

  const logoUrl = excelImage ? excelImage : minnotra_logo;
  const imageBuffer = await getImageBufferFromUrl(logoUrl);
  const imageId = workbook.addImage({
    buffer: imageBuffer,
    extension: "png",
  });

  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.2 },
    ext: { width: 100, height: 38 },
  });

  worksheet.mergeCells("A3:F3");
  const titleCell = worksheet.getCell("A3");
  titleCell.value = "Consumption Report";
  titleCell.font = { size: 14, bold: true };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };

  worksheet.mergeCells("A4:C4");
  worksheet.mergeCells("D4:F4");
  worksheet.getCell("A4").value =
    `From: ${fromDate?.replace("T", " ").replace(".000Z", " ") || "N/A"}`;
  worksheet.getCell("D4").value =
    `To: ${toDate?.replace("T", " ").replace(".000Z", " ") || "N/A"}`;
  worksheet.getRow(4).font = { bold: true };

  const headers = [
    "Site Name",
    "Meter Name",
    "Meter ID",
    "Opening  ",
    "Closing  ",
    "Consumption",
  ];
  worksheet.addRow(headers);

  // Step 6: Style header row
  const headerRow = worksheet.getRow(5);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" }, // Green header
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" }, // White text
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Step 7: Add data rows
  let totalConsumption = 0;
  data.forEach((item) => {
    const consumption = item.consumption || 0;
    totalConsumption += consumption;

    const row = worksheet.addRow([
      item.sitename || "",
      item.metername || "",
      item.meterid || "",
      item.opening || 0,
      item.closing || 0,
      consumption,
    ]);

    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // Step 8: Total row with shade
  const totalRow = worksheet.addRow([
    "",
    "",
    "",
    "",
    "Total Consumption:",
    totalConsumption,
  ]);
  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9EAD3" }, // Light green shade
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 📏 Step 9: Auto-fit column widths
  worksheet.columns.forEach((col) => {
    let maxLength = 0;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, val.length);
    });
    col.width = maxLength < 12 ? 12 : maxLength + 2; // minimum 12, padding +2
  });

  // Step 10: Save file with timestamped name
  const now = new Date();
  const timestamp = now
    .toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(/[/,: ]/g, "-");

  const filename = `Consumption_Report_${timestamp}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};

  // const today = dayjs();
  // const startOfWeek = dayjs().weekday(0); // Sunday
  // const endOfWeek = dayjs().weekday(6); // Saturday
  // const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
  // const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
  // const startOfMonth = dayjs().startOf("month");
  // const endOfMonth = dayjs().endOf("month");
  // const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
  // const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");

  // const rangePresets = [
  //   //  { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
  //   //  { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.subtract(1, "day").endOf("day")] },
  //   { label: "This Week", value: [startOfWeek, endOfWeek] },
  //   { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
  //   { label: "This Month", value: [startOfMonth, endOfMonth] },
  //   { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
  //   { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
  //   { label: "Last 14 Days", value: [dayjs().subtract(14, "day"), today] },
  //   { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
  //   { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
  // ];
  const today = dayjs();
  const startOfWeek = dayjs().startOf("week").startOf("day"); 
  const endOfWeek = dayjs().endOf("week").startOf("day");     
  
  const startOfLastWeek = dayjs().subtract(1, "week").startOf("week").startOf("day"); // Previous Sunday 12:00 AM
  const endOfLastWeek = dayjs().subtract(1, "week").endOf("week").startOf("day");     // Previous Saturday 12:00 AM
  
  const startOfMonth = dayjs().startOf("month").startOf("day");     // 1st of this month 12:00 AM
  const endOfMonth = dayjs().endOf("month").startOf("day");         // Last of this month 12:00 AM
  
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month").startOf("day");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month").startOf("day");
  
  const rangePresets = [
    { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day").startOf("day"), today.startOf("day")] },
  ];
  const handleDateChange = (value) => {
    // if (!value) return;
    // const diff = value[1]?.diff(value[0], "day");

    // if (diff > MAX_DAYS) {
    //   alert("Date range cannot exceed 90 days");
    //   return;
    // }

    if (value) {
      // const fromDate = value[0];
      // const toDate = value[1];
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
      if(!fromDate&& !toDate){
        setDatesError('Please select a date range');
      }else{
        setDatesError(null)
      }

      // //console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
      onChangeFromDate(fromDate);
      onChangeToDate(toDate);
    } else {
      setDatesError('Please select a date range');
    }
  };
  // //console.log(datesError)

  return (
    <div className=" rounded-md w-auto p-4">
      {/* <h4 className={`text-left text-[20px] mb-0 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>CONSUMPTION REPORT</h4> */}

      <div className="flex justify-between items-center px-0 pb-0">
        <div className="text-3xl">
          <p
            className={` dark ${isdarkMode ? "darkfont" : "whitemode"} text-center pb-0  ml-0 font-[500] tracking-[1px]`}
          >
            CONSUMPTION REPORT
          </p>
        </div>
        <div className="flex my-2 gap-2">
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{
              "--secondary-color": color.themeConfig.secondaryColor,
              "--primary-color": color.themeConfig.colorPrimary,
            }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
          <Button
            size="large"
            type="primary"
            disabled={consumptionData.length === 0}
            onClick={() =>
              exportToExcel(consumptionData, excelFromDate, excelToDate)
            }
            // className={isdarkMode? "text-white":"text-black"}
          >
            Create Excel
          </Button>
        </div>
      </div>
      {!loadings && !loading && consumptionData.length > 0 && (
        <div className={`m-2`}>
          <TableComponentReport report={consumptionData} meters={columns} />
        </div>
      ) 
      
    }
    {!loadings && !loading && consumptionData.length === 0 &&
       (
        <div
          className={`${!isdarkMode ? "text-black " : "text-white "} text-center`}
        >
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        </div>
      )}
    {loading && (
                <Skeleton active paragraph={{ rows: 6 }} />
      
        // <div
        //   className={`${!isdarkMode ? "text-black " : "text-white "} text-center`}
        // >
        //   <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        // </div>
      )}

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
              selectedValues={converterId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          
    <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId == 1
                ? nsGetElectricConverterMeterList
                : getElectricGroupMeterList
            }
            idKey={ "meterid"}
            valueKey={ "meterid"}
            nameKey={ "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
           <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
           <SteamTreeSelectCustomWithSelectAll
                      label="Parameters:"
                      data={parameter}
                      idKey="parameterid"
                      nameKey="parametername"
                      valueKey="parametername"
                      selectedValues={selectedValues}
                      onSelect={handleTreeChange}
                      isMultipleSelect={false}
                      isSelectAll={false}
                    />
                    <small className="text-red-500 font-bold ml-[150px]">
                      {paraError}
                      {/* {parameterLenght} */}
                    </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left"> Date:</label>
            <RangePicker
              value={value}
              onChange={handleDateChange}
              popupClassName="custom-picker"
              presets={rangePresets}
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ format: "HH:mm:ss" }}
              className={`w-80 ml-0 shadow-lg rounded-3xl  ${
                isdarkMode
                  ? "customRangePicker-dark  text-white"
                  : "customRangePicker-light text-black"
              }`}
              panelRender={(originalPanel) => {
                if (!showCalendar) {
                  return (
                    <div
                      className={`${
                        isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
                      } flex flex-col gap-1 p-2 w-44 rounded`}
                    >
                      {rangePresets.map((preset) => (
                        <div
                          key={preset.label}
                          onClick={() => handleDateChange(preset.value)}
                          className={`cursor-pointer px-2 py-1 rounded ${
                            isdarkMode
                              ? "text-white hover:bg-gray-700"
                              : "text-black hover:bg-gray-200"
                          }`}
                        >
                          {preset.label}
                        </div>
                      ))}
                      <button
                        onClick={() => setShowCalendar(true)}
                        className={`mt-2 px-2 py-1 rounded  border text-center ${
                          isdarkMode
                            ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                            : "bg-white border-black text-black hover:bg-gray-200"
                        }`}
                      >
                        Custom Dates
                      </button>
                    </div>
                  );
                }
                return originalPanel;
              }}
              onOpenChange={(open) => {
                if (!open) setShowCalendar(false);
              }}
            />
          </div>
              <small className="text-red-500 font-bold ml-[150px]">
            {datesError}
          </small>
         
        </div>

        <div className="flex justify-center mt-4">
          {/* <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#52c41a", // Green color
                colorPrimaryHover: "#40a700", // Darker green on hover
                colorBgContainer: isdarkMode === "dark" ? "#292c35" : "#f6ffed",
                colorTextBase: isdarkMode === "dark" ? "#fff" : "#000",
              },
            }}
          >
          </ConfigProvider> */}
          <Button
            type={isdarkMode ? "" : "primary"}
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
           .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ConsumptionReportElectrical;
